import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignsListHandoff } from '@/pages/workspaces/automations/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/automations` list URL. Flag off the embedded app serves it; flag on it
 * forwards to the migrated list. The resolver belongs here: this URL keeps the `journeys` segment,
 * so a `/workspaces/last` sentinel has to resolve before the embedded app mounts on it.
 */
function JourneysAutomationsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCampaignsListHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/automations/')({
  component: JourneysAutomationsIndexRoute,
});
